module.exports = __webpack_public_path__ + "static/sommer-05-8010c5a4eb0bbbceb141cbf5d6e47136.jpg";